import styles from './index.less?modules';
import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'dva';
import { isEmptyObject } from '@/utils/comUtil';
import { Radio } from 'antd';
import DataTable from '@/containers/data_table_ml/DataTable';
import { fieldType } from '@/constants.js';
import Search from './components/search/Search';
import ButtonML from '@/components/button_ml/ButtonML';
import { Collapse } from 'antd';

const { Panel } = Collapse;

const Fop = (props) => {
  // 发起请求
  const dispatch = useDispatch();
  const { handleCancel, changeOptions } = props;
  const constructList = useSelector((state) => state.bre.allConstructList);
  const constructDetailList = useSelector(
    (state) => state.bre.constructDetailList,
  );
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['bre/getConstructDetail'];
  const [ruleSeledId, setRuleSeledId] = useState(null); //规则包id
  const [modelSeledId, setModelSeledId] = useState(null); //模型包id

  const [searchValue, setSearchValue] = useState(null);
  const [seledRows, setSeledRows] = useState(null);
  const handleChangeRuleId = (e) => {
    //先清空另外一组
    setModelSeledId(null);
    setRuleSeledId(e.target.value);
  };
  const handleChangeModelId = (e) => {
    //先清空另外一组
    setRuleSeledId(null);
    setModelSeledId(e.target.value);
  };
  //获取字段包列表
  const getAllConstruct = useCallback(() => {
    dispatch({
      type: 'bre/getConstruct',
    });
  }, [dispatch]);
  //获取字段包详情
  const getConstructDetails = useCallback(() => {
    let seledId = ruleSeledId || modelSeledId;
    if (!seledId) {
      return;
    }
    dispatch({
      type: 'bre/getConstructDetails',
      payload: {
        values: {
          nodeBlock: seledId,
          nodeBlockType: ruleSeledId === null ? 'MODEL' : 'RULE',
        },
      },
    });
  }, [dispatch, ruleSeledId, modelSeledId]);
  //清空列表的数据
  const resetConstructDetails = () => {
    dispatch({
      type: 'bre/resetConstructDetails',
    });
  };
  const columns = [
    {
      title: '输出项名称',
      dataIndex: 'name',
      key: 'name',
      width: '30%',
    },
    {
      title: '字段类型',
      dataIndex: 'fieldType',
      key: 'fieldType',
      width: '30%',
      render: (text) => fieldType[text],
    },
  ];
  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      setSeledRows(selectedRows);
    },
    onSelectAll: (selected, selectedRows) => {
      setSeledRows(selectedRows);
    },
    columnWidth: 40,
  };
  const handleSubmit = () => {
    //提交的时候获取选中的数据
    console.log(seledRows);
    handleCancel();
    resetConstructDetails();
    changeOptions && changeOptions(seledRows);
  };
  useEffect(() => {
    if (!isEmptyObject(constructList)) {
      return;
    }
    getAllConstruct();
  }, [constructList, getAllConstruct]);
  useEffect(() => {
    getConstructDetails();
  }, [getConstructDetails]);
  return (
    <div className={styles.box}>
      <div className={styles.left}>
        <Collapse>
          <Panel header="规则包" key="2">
            <Radio.Group onChange={handleChangeRuleId} value={ruleSeledId}>
              {!isEmptyObject(constructList) &&
                constructList
                  .filter((item) => item.nodeBlockType === 'RULE')
                  .map((item) => {
                    return (
                      <Radio
                        value={item.nodeBlock}
                        key={item.nodeBlock}
                        className={styles.radio}
                      >
                        {item.nodeBlockName}
                      </Radio>
                    );
                  })}
            </Radio.Group>
          </Panel>
          <Panel header="模型包" key="3">
            <Radio.Group onChange={handleChangeModelId} value={modelSeledId}>
              {!isEmptyObject(constructList) &&
                constructList
                  .filter((item) => item.nodeBlockType === 'MODEL')
                  .map((item) => {
                    return (
                      <Radio
                        value={item.nodeBlock}
                        key={item.nodeBlock}
                        className={styles.radio}
                      >
                        {item.nodeBlockName}
                      </Radio>
                    );
                  })}
            </Radio.Group>
          </Panel>
        </Collapse>
      </div>

      <div className={styles.right}>
        <Search setSearchValue={setSearchValue} />
        <div className={styles.right_table}>
          <DataTable
            className="demo-test"
            columns={columns}
            rowSelection={rowSelection}
            scroll={{ y: 'calc(70vh - 48px * 5)' }}
            style={{ height: 'calc(70vh - 48px * 4)' }}
            dataSource={
              constructDetailList &&
              constructDetailList.filter((item) =>
                item.name.includes(searchValue || ''),
              )
            }
            loading={loading}
            isTree={true}
          />
        </div>
        <div className={styles.right_top}>
          <ButtonML size="large" value="提交" onClick={handleSubmit} />
        </div>
      </div>
    </div>
  );
};
export default Fop;
